import { render, staticRenderFns } from "./GestionBonoAsignacionMonto.vue?vue&type=template&id=277036ac"
import script from "./GestionBonoAsignacionMonto.vue?vue&type=script&lang=js"
export * from "./GestionBonoAsignacionMonto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports